<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">{{ $t("loadingTxt") }}...</div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <div class="row mb-3">
                    <h4 style="margin-right: 5px" class="float-start">
                      {{ $t("cml_billing_detail_handling_in") }}
                    </h4>
                  </div>

                  <div class="card-body" v-show="this.forms.subDetailRateFlag === 'Y'">
                    <div class="row mb-3">
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("idDetailHandling") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="idDetailHandling"
                          :placeholder="$t('idDetailHandling')"
                          v-model="formsHandling.idDetailHandling"
                          disabled
                        />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("idBillingDetail") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="idBillingDetail"
                          :placeholder="$t('idBillingDetail')"
                          v-model="formsHandling.idBillingDetail"
                          disabled
                        />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("locationCategory") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="locationCategory"
                          :placeholder="$t('locationCategory')"
                          v-model="formsHandling.locationCategory"
                          disabled
                        />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("zone") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="zone"
                          :placeholder="$t('zone')"
                          v-model="formsHandling.zone"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("keyLocation") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="keyLocation"
                          :placeholder="$t('keyLocation')"
                          v-model="formsHandling.keyLocation"
                          disabled
                        />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("uom") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="uom"
                          :placeholder="$t('uom')"
                          v-model="formsHandling.UOM"
                          disabled
                        />
                      </div>
                      <div class="col-md-6">
                        <label class="form-label">{{ $t("rateBaseDesc_txt") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="rateBaseDesc"
                          :placeholder="$t('rateBaseDesc_txt')"
                          v-model="formsHandling.rateBaseDesc"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("qty_txt") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="qty"
                          :placeholder="$t('qty_txt')"
                          v-model="formsHandling.qty"
                          disabled
                        />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("rate") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="rate"
                          :placeholder="$t('rate')"
                          v-model="formsHandling.rate"
                          disabled
                        />
                      </div>
                      <div class="col-md-6">
                        <label class="form-label">{{ $t("amount_txt") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="amount"
                          :placeholder="$t('amount_txt')"
                          v-model="formsHandling.amount"
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <div class="card-body" v-show="this.forms.subDetailRateFlag === 'N'">
                    <div class="row mb-3">
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("idBillingDetail") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="idBillingDetail"
                          :placeholder="$t('idBillingDetail')"
                          v-model="forms.idBillingDetail"
                          disabled
                        />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("idBillingHeader") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="idBillingHeader"
                          :placeholder="$t('idBillingHeader')"
                          v-model="forms.idBillingHeader"
                          disabled
                        />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("SAPMaterialCode") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="SAPMaterialCode"
                          :placeholder="$t('SAPMaterialCode')"
                          v-model="forms.SAPMaterialCode"
                          disabled
                        />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("SAPDivision") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="SAPDivision"
                          :placeholder="$t('SAPDivision')"
                          v-model="forms.SAPDivision"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("chargeCategory_txt") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="chargeCategory"
                          :placeholder="$t('chargeCategory_txt')"
                          v-model="forms.chargeCategory"
                          disabled
                        />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("chargeType_txt") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="chargeType"
                          :placeholder="$t('chargeType_txt')"
                          v-model="forms.chargeType"
                          disabled
                        />
                      </div>
                      <div class="col-md-6">
                        <label class="form-label">{{ $t("rateBaseDesc_txt") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="rateBaseDesc"
                          :placeholder="$t('rateBaseDesc_txt')"
                          v-model="forms.rateBaseDesc"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("qtyCharge") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="qtyCharge"
                          :placeholder="$t('qtyCharge')"
                          v-model="forms.qtyCharge"
                          disabled
                        />
                      </div>
                      <div
                        class="col-md-3"
                        v-show="
                          this.roleName !== 'om_cml_basf01' &&
                          this.roleName !== 'om_cml_basf02_rm' &&
                          this.roleName !== 'om_cml_basf02_fg'
                        "
                      >
                        <label class="form-label">{{ $t("rate") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="rate"
                          :placeholder="$t('rate')"
                          v-model="forms.rate"
                          disabled
                        />
                      </div>
                      <div
                        class="col-md-3"
                        v-show="
                          this.roleName !== 'om_cml_basf01' &&
                          this.roleName !== 'om_cml_basf02_rm' &&
                          this.roleName !== 'om_cml_basf02_fg'
                        "
                      >
                        <label class="form-label">{{ $t("amountCategory") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="amountCategory"
                          :placeholder="$t('amountCategory')"
                          v-model="forms.amountCategory"
                          disabled
                        />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("remarks_txt") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="remark"
                          :placeholder="$t('remarks_txt')"
                          v-model="forms.remark"
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <button
                    v-if="permision_role.method_read"
                    class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()"
                  >
                    <span class="mdi mdi-download h4"></span>
                    {{ $t("downloadData") }} .xlsx
                  </button>
                  <button
                    class="btn btn-primary text-light fw-bolder btn-icon-text"
                    @click="backForm"
                    type="button"
                  >
                    <i class="link-icon mdi mdi-arrow-left"></i>
                    {{ $t("backMess") }}
                  </button>
                </div>

                <span
                  v-if="
                    this.roleName == 'om_cml_basf01' ||
                    this.roleName == 'om_cml_basf02_rm' ||
                    this.roleName == 'om_cml_basf02_fg'
                  "
                >
                  <div
                    class="card-body"
                    v-if="
                      (formsHeader.sapDataFlag !== 'Y' &&
                        formsHeader.status === 'COMPLETED') ||
                      formsHeader.status === 'PROCESSING'
                    "
                  >
                    <vue-good-table
                      title="list-billing-cml-billing-detail-handling-in"
                      ref="list-billing-cml-billing-detail-handling-in"
                      :select-options="{
                        enabled: true,
                        selectOnCheckboxOnly: true,
                        selectionText: $t('data_selected'),
                        clearSelectionText: $t('clear'),
                      }"
                      mode="remote"
                      styleClass="vgt-table striped"
                      @on-selected-rows-change="selectionChanged"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      :totalRows="totalRecords"
                      :line-numbers="true"
                      :isLoading.sync="isLoading"
                      :pagination-options="{
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                        //position: 'top',
                      }"
                      :rows="rows"
                      :columns="columns"
                    >
                      <div slot="table-actions">
                        {{ $t("no_select_data") }}
                      </div>

                      <div slot="selected-row-actions">
                        <button
                          class="btn btn-danger btn-xs"
                          style="margin-right: 20px"
                          @click="selectionChangeStatus"
                        >
                          <i class="mdi mdi-send-outline"></i>
                          {{ $t("changeStatus") }}
                        </button>

                        <button class="btn btn-success btn-xs" @click="removeSelections">
                          <i class="mdi mdi-close"></i>
                          {{ $t("unselect_data_txt") }}
                        </button>
                      </div>

                      <template slot="column-filter" slot-scope="{ column }">
                        <span v-if="column.filterOptions.customFilter">
                          <span v-if="column.field == 'receiveDate'">
                            <date-range-picker
                              style="width: 100%"
                              @update="receiveDateChange"
                              control-container-class="form-control"
                              :locale-data="{ format: 'yyyy-mm-dd' }"
                              v-model="receiveDate"
                              :opens="opens"
                              :singleDatePicker="false"
                              :timePicker24Hour="false"
                              :timePicker="false"
                              :showWeekNumbers="false"
                            >
                              <div slot="header" slot-scope="header" class="slot">
                                <a
                                  @click="clearreceiveDateChange()"
                                  class="float-end"
                                  style="margin-right: 5px; color: red"
                                  >Clear Calendar</a
                                >
                                <span v-if="header.in_selection"> - in selection</span>
                                <br />
                              </div>
                            </date-range-picker>
                          </span>
                        </span>
                      </template>

                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'">
                          <a
                            href="#"
                            v-if="
                              permision_role.method_update && props.row.status === 'BILL'
                            "
                            title="NOT BILL"
                            @click.prevent="
                              changeStatusData(props.index, props.row, 'NOT BILL')
                            "
                          >
                            <button class="btn btn-danger btn-xs">NOT BILL</button>
                          </a>
                          <a
                            href="#"
                            v-else
                            @click.prevent="
                              changeStatusData(props.index, props.row, 'BILL')
                            "
                          >
                            <button class="btn btn-primary btn-xs">BILL</button>
                          </a>
                        </span>
                        <span v-else-if="props.column.field == 'amount'"> - </span>
                        <span v-else-if="props.column.field == 'rate'"> - </span>

                        <span v-else-if="props.column.field == 'status'">
                          <span
                            v-if="props.row.status == 'BILL'"
                            class="badge bg-primary"
                          >
                            <h5>{{ props.row.status }}</h5>
                          </span>
                          <span v-else class="badge bg-danger">
                            <h5>{{ props.row.status }}</h5>
                          </span>
                        </span>

                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>
                    </vue-good-table>
                  </div>
                  <div class="card-body" v-else>
                    <vue-good-table
                      title="list-billing-cml-billing-detail-handling-in"
                      ref="list-billing-cml-billing-detail-handling-in"
                      mode="remote"
                      styleClass="vgt-table striped"
                      @on-selected-rows-change="selectionChanged"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      :totalRows="totalRecords"
                      :line-numbers="true"
                      :isLoading.sync="isLoading"
                      :pagination-options="{
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                        //position: 'top',
                      }"
                      :rows="rows"
                      :columns="columns"
                    >
                      <div slot="table-actions">
                        {{ $t("no_select_data") }}
                      </div>

                      <template slot="column-filter" slot-scope="{ column }">
                        <span v-if="column.filterOptions.customFilter">
                          <span v-if="column.field == 'receiveDate'">
                            <date-range-picker
                              style="width: 100%"
                              @update="receiveDateChange"
                              control-container-class="form-control"
                              :locale-data="{ format: 'yyyy-mm-dd' }"
                              v-model="receiveDate"
                              :opens="opens"
                              :singleDatePicker="false"
                              :timePicker24Hour="false"
                              :timePicker="false"
                              :showWeekNumbers="false"
                            >
                              <div slot="header" slot-scope="header" class="slot">
                                <a
                                  @click="clearreceiveDateChange()"
                                  class="float-end"
                                  style="margin-right: 5px; color: red"
                                  >Clear Calendar</a
                                >
                                <span v-if="header.in_selection"> - in selection</span>
                                <br />
                              </div>
                            </date-range-picker>
                          </span>
                        </span>
                      </template>

                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'"> - </span>
                        <span v-else-if="props.column.field == 'amount'"> - </span>
                        <span v-else-if="props.column.field == 'rate'"> - </span>
                        <span v-else-if="props.column.field == 'status'">
                          <span
                            v-if="props.row.status == 'BILL'"
                            class="badge bg-primary"
                          >
                            <h5>{{ props.row.status }}</h5>
                          </span>
                          <span v-else class="badge bg-danger">
                            <h5>{{ props.row.status }}</h5>
                          </span>
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>
                    </vue-good-table>
                  </div>
                </span>

                <span v-else>
                  <div
                    class="card-body"
                    v-if="
                      (formsHeader.sapDataFlag !== 'Y' &&
                        formsHeader.status === 'COMPLETED') ||
                      formsHeader.status === 'PROCESSING'
                    "
                  >
                    <vue-good-table
                      title="list-billing-cml-billing-detail-handling-in"
                      ref="list-billing-cml-billing-detail-handling-in"
                      :select-options="{
                        enabled: true,
                        selectOnCheckboxOnly: true,
                        selectionText: $t('data_selected'),
                        clearSelectionText: $t('clear'),
                      }"
                      mode="remote"
                      styleClass="vgt-table striped"
                      @on-selected-rows-change="selectionChanged"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      :totalRows="totalRecords"
                      :line-numbers="true"
                      :isLoading.sync="isLoading"
                      :pagination-options="{
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                        //position: 'top',
                      }"
                      :rows="rows"
                      :columns="columns"
                    >
                      <div slot="table-actions">
                        {{ $t("no_select_data") }}
                      </div>

                      <div slot="selected-row-actions">
                        <button
                          class="btn btn-danger btn-xs"
                          style="margin-right: 20px"
                          @click="selectionChangeStatus"
                        >
                          <i class="mdi mdi-send-outline"></i>
                          {{ $t("changeStatus") }}
                        </button>

                        <button class="btn btn-success btn-xs" @click="removeSelections">
                          <i class="mdi mdi-close"></i>
                          {{ $t("unselect_data_txt") }}
                        </button>
                      </div>

                      <template slot="column-filter" slot-scope="{ column }">
                        <span v-if="column.filterOptions.customFilter">
                          <span v-if="column.field == 'receiveDate'">
                            <date-range-picker
                              style="width: 100%"
                              @update="receiveDateChange"
                              control-container-class="form-control"
                              :locale-data="{ format: 'yyyy-mm-dd' }"
                              v-model="receiveDate"
                              :opens="opens"
                              :singleDatePicker="false"
                              :timePicker24Hour="false"
                              :timePicker="false"
                              :showWeekNumbers="false"
                            >
                              <div slot="header" slot-scope="header" class="slot">
                                <a
                                  @click="clearreceiveDateChange()"
                                  class="float-end"
                                  style="margin-right: 5px; color: red"
                                  >Clear Calendar</a
                                >
                                <span v-if="header.in_selection"> - in selection</span>
                                <br />
                              </div>
                            </date-range-picker>
                          </span>
                        </span>
                      </template>

                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'">
                          <a
                            href="#"
                            v-if="
                              permision_role.method_update && props.row.status === 'BILL'
                            "
                            title="NOT BILL"
                            @click.prevent="
                              changeStatusData(props.index, props.row, 'NOT BILL')
                            "
                          >
                            <button class="btn btn-danger btn-xs">NOT BILL</button>
                          </a>
                          <a
                            href="#"
                            v-else
                            @click.prevent="
                              changeStatusData(props.index, props.row, 'BILL')
                            "
                          >
                            <button class="btn btn-primary btn-xs">BILL</button>
                          </a>
                        </span>
                        <span v-else-if="props.column.field == 'amount'">
                          {{ toCurrency(props.row.amount) }}
                        </span>
                        <span v-else-if="props.column.field == 'rate'">
                          {{ toCurrency(props.row.rate) }}
                        </span>

                        <span v-else-if="props.column.field == 'status'">
                          <span
                            v-if="props.row.status == 'BILL'"
                            class="badge bg-primary"
                          >
                            <h5>{{ props.row.status }}</h5>
                          </span>
                          <span v-else class="badge bg-danger">
                            <h5>{{ props.row.status }}</h5>
                          </span>
                        </span>

                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>
                    </vue-good-table>
                  </div>
                  <div class="card-body" v-else>
                    <vue-good-table
                      title="list-billing-cml-billing-detail-handling-in"
                      ref="list-billing-cml-billing-detail-handling-in"
                      mode="remote"
                      styleClass="vgt-table striped"
                      @on-selected-rows-change="selectionChanged"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      :totalRows="totalRecords"
                      :line-numbers="true"
                      :isLoading.sync="isLoading"
                      :pagination-options="{
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                        //position: 'top',
                      }"
                      :rows="rows"
                      :columns="columns"
                    >
                      <div slot="table-actions">
                        {{ $t("no_select_data") }}
                      </div>

                      <template slot="column-filter" slot-scope="{ column }">
                        <span v-if="column.filterOptions.customFilter">
                          <span v-if="column.field == 'receiveDate'">
                            <date-range-picker
                              style="width: 100%"
                              @update="receiveDateChange"
                              control-container-class="form-control"
                              :locale-data="{ format: 'yyyy-mm-dd' }"
                              v-model="receiveDate"
                              :opens="opens"
                              :singleDatePicker="false"
                              :timePicker24Hour="false"
                              :timePicker="false"
                              :showWeekNumbers="false"
                            >
                              <div slot="header" slot-scope="header" class="slot">
                                <a
                                  @click="clearreceiveDateChange()"
                                  class="float-end"
                                  style="margin-right: 5px; color: red"
                                  >Clear Calendar</a
                                >
                                <span v-if="header.in_selection"> - in selection</span>
                                <br />
                              </div>
                            </date-range-picker>
                          </span>
                        </span>
                      </template>

                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'"> - </span>
                        <span v-else-if="props.column.field == 'amount'">
                          {{ toCurrency(props.row.amount) }}
                        </span>
                        <span v-else-if="props.column.field == 'rate'">
                          {{ toCurrency(props.row.rate) }}
                        </span>
                        <span v-else-if="props.column.field == 'status'">
                          <span
                            v-if="props.row.status == 'BILL'"
                            class="badge bg-primary"
                          >
                            <h5>{{ props.row.status }}</h5>
                          </span>
                          <span v-else class="badge bg-danger">
                            <h5>{{ props.row.status }}</h5>
                          </span>
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>
                    </vue-good-table>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from "vue2-daterange-picker";

export default {
  name: "CmlBillingDetailHandlingIn",
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DateRangePicker,
  },
  data() {
    return {
      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },
      receiveDate: {
        startDate: null,
        endDate: null,
      },
      firstDates: {
        startDate: null,
        endDate: null,
      },
      highlighted: {
        dates: [
          // Highlight an array of dates
          new Date(),
        ],
      },
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role: [],
      langs: ["id", "en"],
      detailUser: [],
      idBillingHeader: [],
      detailDivisi: [],
      totalRecords: 0,
      receiveDateFrom: "",
      firstBilingDate: "",
      receiveDateTo: "",
      roleName: "",
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: this.getTableColumns(),
      rows: [],
      rowsSelection: [],
      idCodeLkupsSelections: [],
      idBillingDetail: this.$route.params.idBillingDetail || "",
      formsHandling: {
        rateBaseDesc: "",
        idDetailHandling: "",
        idBillingDetail: "",
        locationCategory: "",
        zone: "",
        rate: "",
        qty: "",
        UOM: "",
        amount: "",
        addwho: "",
        editwho: "",
        keyLocation: "",
        rateBaseName: "",
      },
      forms: {
        remark: "",
        rateBaseDesc: "",
        idBillingDetail: "",
        idBillingHeader: "",
        chargeCategory: "",
        chargeType: "",
        SAPMaterialCode: "",
        SAPDivision: "",
        amountCategory: "",
        addwho: "",
        editwho: "",
        qtyCharge: "",
        rate: "",
        subDetailRateFlag: "",
      },
      formsHeader: {
        idBillingHeader: "",
        tariffId: "",
        customerId: "",
        warehouseId: "",
        transactionToDate: "",
        transactionFromDate: "",
        status: "",
        amount: "",
        idRateHeader: "",
        transactionDate: "",
        addwho: "",
        editwho: "",
        adddate: "",
        editdate: "",
      },
    };
  },
  watch: {},
  methods: {
    getTableColumns() {
      // Role yang tidak menampilkan kolom amountCategory
      const hiddenRoles = [
        "om_bulk",
        "om_cml_basf01",
        "om_cml_basf02_rm",
        "om_cml_basf02_fg",
      ];

      const roleName = this.permision_role?.role?.name;
      const isHiddenRole = hiddenRoles.includes(roleName);

      // Define columns with a fixed order
      let columns = [
        {
          label: this.$t("idDetailHandlingIn"),
          field: "idDetailHandlingIn",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("idDetailHandlingIn"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("statusTxt"),
          field: "status",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("statusTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ["BILL", "NOT BILL"], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("poReference"),
          field: "poReference",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("poReference"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("receiveDate"),
          field: "receiveDate",
          thClass: "text-center",
          width: "100px",
          type: "date",
          dateInputFormat: "yyyy-MM-dd HH:mm:ss",
          dateOutputFormat: "yyyy-MM-dd",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: true,
            placeholder: this.$t("receiveDate"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("skuCodeTxt"),
          field: "sku",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("skuCodeTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("skuDescriptionTxt"),
          field: "skuDesc",
          width: "200px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("skuDescriptionTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qty_txt"),
          field: "qty",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("qty_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        !isHiddenRole
          ? {
              label: this.$t("rate_txt"),
              field: "rate",
              filterOptions: {
                enabled: false, // enable filter for this column
                customFilter: false,
              },
            }
          : null,
        !isHiddenRole
          ? {
              label: this.$t("amount_txt"),
              field: "amount",
              filterOptions: {
                enabled: false, // enable filter for this column
                customFilter: false,
              },
            }
          : null,
        {
          label: this.$t("action_txt"),
          field: "actions",
          width: "100px",
          sortable: false,
          filterOptions: {
            customFilter: false,
            enabled: false,
          },
        },
        {
          label: this.$t("additionalFlag"),
          field: "additionalFlag",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("all"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ["Y", "N"], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("arrNo"),
          field: "arrNo",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("arrNo"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("movementType"),
          field: "movementType",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("movementType"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("plant"),
          field: "plant",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("plant"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("sloc"),
          field: "sloc",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("sloc"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("key1"),
          field: "key1",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("key1"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("skuGroup"),
          field: "skuGroup",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("skuGroup"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("docNo"),
          field: "docNo",
          width: "150px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("docNo"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("docType"),
          field: "docType",
          width: "150px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("docType"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("locationId"),
          field: "locationId",
          width: "150px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("locationId"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("zone"),
          field: "zone",
          width: "150px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("zone"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("traceId"),
          field: "traceId",
          width: "150px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("traceId"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("MUID"),
          field: "MUID",
          width: "150px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("MUID"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("palletType"),
          field: "lotAtt07",
          width: "150px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("palletType"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("batch"),
          field: "batch",
          width: "150px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("batch"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qtyEA"),
          field: "qtyEA",
          width: "150px",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("qtyEA"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("uom"),
          field: "uom",
          width: "150px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("uom"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("cube"),
          field: "Cube",
          width: "150px",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("cube"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("totalCube"),
          field: "totalCube",
          width: "150px",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("totalCube"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qtyCase"),
          field: "qtyCase",
          width: "150px",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("qtyCase"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qtyPerPallet"),
          field: "qtyPallet",
          width: "150px",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("qtyPerPallet"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("editwho"),
          field: "editwho",
          width: "150px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("editwho"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ];

      // Filter kolom null (saat hidden) dari array
      return columns.filter((column) => column !== null);
    },

    changeStatusData(index, row, statusNya) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            idBillingHeader: this.formsHeader.idBillingHeader,
            idBillingDetail: this.forms.idBillingDetail,
            idDetailHandlingIns: [row.idDetailHandlingIn],
            status: statusNya,
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/billing/bt-billing-detail-handling-in-charge-update-status";
          this.$http
            .post(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    selectionChangeStatus() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "BILL",
        cancelButtonText: "NOT BILL",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;

          let formData = {
            idBillingHeader: this.formsHeader.idBillingHeader,
            idBillingDetail: this.forms.idBillingDetail,
            idDetailHandlingIns: this.idCodeLkupsSelections,
            status: "BILL",
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/billing/bt-billing-detail-handling-in-charge-update-status";
          this.$http
            .post(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.idCodeLkupsSelections = [];
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = true;
          let formData = {
            idBillingHeader: this.formsHeader.idBillingHeader,
            idBillingDetail: this.forms.idBillingDetail,
            idDetailHandlingIns: this.idCodeLkupsSelections,
            status: "NOT BILL",
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/billing/bt-billing-detail-handling-in-charge-update-status";
          this.$http
            .post(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.idCodeLkupsSelections = [];
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        }
      });
    },

    removeSelections() {
      this.idCodeLkupsSelections = [];
      this.$refs["list-billing-cml-billing-detail-handling-in"].unselectAllInternal();
    },

    selectionChanged(ev) {
      this.rowsSelection = [];
      this.idCodeLkupsSelections = [];
      this.rowsSelection = ev.selectedRows;

      this.rowsSelection.forEach((item) => {
        this.idCodeLkupsSelections.push(item.idDetailHandlingIn);
      });
    },

    receiveDateChange() {
      if (this.receiveDate.startDate && this.receiveDate.endDate) {
        this.receiveDateFrom = this.$moment(String(this.receiveDate.startDate)).format(
          "YYYY-MM-DD"
        );
        this.receiveDateTo = this.$moment(String(this.receiveDate.endDate)).format(
          "YYYY-MM-DD"
        );
        this.loadItems();
      }
    },

    clearreceiveDateChange() {
      this.receiveDate = {
        startDate: null,
        endDate: null,
      };
      this.receiveDateFrom = "";
      this.receiveDateTo = "";
      this.loadItems();
    },

    backForm() {
      var subDetailRateFlag = this.forms.subDetailRateFlag;
      var idBillingDetail = this.idBillingDetail;
      var idBillingHeader = this.$onRandom(this.$route.params.idBillingHeader);
      if (subDetailRateFlag === "Y") {
        window.location.href =
          "/billing-cml/billing/detail-handling/" +
          idBillingDetail +
          "/" +
          this.$route.params.idBillingHeader;
      } else if (subDetailRateFlag === "N") {
        window.location.href = "/billing-cml/billing/header/detail/" + idBillingHeader;
      }
    },

    toCurrency(value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IDR",
      });
      return formatter.format(value);
    },

    downloadData() {
      var params = this.$onBehind(this.$route.params.idBillingDetail);
      const userDatas = this.$getUserInfo();
      var roleName = userDatas.sub.role.name;
      var hideRate = "";
      if (
        roleName == "om_cml_basf01" ||
        roleName == "om_cml_basf02_rm" ||
        roleName == "om_cml_basf02_fg"
      ) {
        hideRate = "-hide-rate";
      }

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-handling-in-charge" +
        hideRate +
        "/" +
        params[0];
      this.isLoading = true;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      let receiveDateFrom = this.receiveDateFrom;
      let receiveDateTo = this.receiveDateTo;

      // Gunakan queryParams untuk menyusun URL
      let queryParams = `?lotAtt07=${this.serverParams.columnFilters.lotAtt07}&arrNo=${this.serverParams.columnFilters.arrNo}&movementType=${this.serverParams.columnFilters.movementType}&key1=${this.serverParams.columnFilters.key1}&sloc=${this.serverParams.columnFilters.sloc}&plant=${this.serverParams.columnFilters.plant}&idDetailHandlingIn=${this.serverParams.columnFilters.idDetailHandlingIn}&poReference=${this.serverParams.columnFilters.poReference}&docNo=${this.serverParams.columnFilters.docNo}&receiveDateFrom=${receiveDateFrom}&receiveDateTo=${receiveDateTo}&docType=${this.serverParams.columnFilters.docType}&sku=${this.serverParams.columnFilters.sku}&skuDesc=${this.serverParams.columnFilters.skuDesc}&uom=${this.serverParams.columnFilters.uom}&MUID=${this.serverParams.columnFilters.MUID}&locationId=${this.serverParams.columnFilters.locationId}&zone=${this.serverParams.columnFilters.zone}&batch=${this.serverParams.columnFilters.batch}&editwho=${this.serverParams.columnFilters.editwho}&status=${this.serverParams.columnFilters.status}&additionalFlag=${this.serverParams.columnFilters.additionalFlag}`;

      // Tambahkan filter idDetailHandling jika subDetailRateFlag === "Y"
      if (this.forms.subDetailRateFlag === "Y" && this.formsHandling.idDetailHandling) {
        queryParams += `&idDetailHandling=${this.formsHandling.idDetailHandling}`;
      }

      // Tambahkan parameter download
      queryParams += `&download=download`;

      return this.$http
        .get(baseURI + queryParams, { responseType: "blob", timeout: 60000 })
        .then((response) => {
          this.isLoading = false;
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        })
        .catch((error) => {
          this.isLoading = false;

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(this.$t("errorTxt"));
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    loadDataDetailHandling() {
      this.isLoading = true;

      var params = this.$onBehind(this.$route.params.idDetailHandling);

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-detail-detail-handling/" +
        params[0];
      return this.$http
        .get(baseURI, { timeout: 60000 })
        .then((response) => {
          this.isLoading = false;
          this.formsHandling = response.data.datas;
          this.formsHandling.amount = this.toCurrency(response.data.datas.amount);
          this.formsHandling.rate = this.toCurrency(response.data.datas.rate);
          this.formsDetailHandling = response.data.datas.bt_billing_detail;
          this.formsHeaderHandling =
          response.data.datas.bt_billing_detail.bm_billing_header;
          
          // Simpan idDetailHandling ke dalam formsHandling
          this.formsHandling.idDetailHandling = response.data.datas.idDetailHandling;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    loadItems() {
      var params = this.$onBehind(this.$route.params.idBillingDetail);
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-handling-in-charge/" +
        params[0];

      this.isLoading = true;

      let receiveDateFrom = this.receiveDateFrom;
      let receiveDateTo = this.receiveDateTo;

      let queryParams = `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}`;

      // Tambahkan filter idDetailHandlingIn jika subDetailRateFlag === "Y"
      if (this.forms.subDetailRateFlag === "Y" && this.formsHandling.idDetailHandling) {
        queryParams += `&idDetailHandling=${this.formsHandling.idDetailHandling}`;
      }

      queryParams += `&idDetailHandlingIn=${this.serverParams.columnFilters.idDetailHandlingIn}&poReference=${this.serverParams.columnFilters.poReference}&docNo=${this.serverParams.columnFilters.docNo}&receiveDateFrom=${receiveDateFrom}&receiveDateTo=${receiveDateTo}&docType=${this.serverParams.columnFilters.docType}&sku=${this.serverParams.columnFilters.sku}&skuDesc=${this.serverParams.columnFilters.skuDesc}&uom=${this.serverParams.columnFilters.uom}&MUID=${this.serverParams.columnFilters.MUID}&locationId=${this.serverParams.columnFilters.locationId}&zone=${this.serverParams.columnFilters.zone}&batch=${this.serverParams.columnFilters.batch}&editwho=${this.serverParams.columnFilters.editwho}&status=${this.serverParams.columnFilters.status}&movementType=${this.serverParams.columnFilters.movementType}&key1=${this.serverParams.columnFilters.key1}&sloc=${this.serverParams.columnFilters.sloc}&plant=${this.serverParams.columnFilters.plant}&arrNo=${this.serverParams.columnFilters.arrNo}&lotAtt07=${this.serverParams.columnFilters.lotAtt07}&additionalFlag=${this.serverParams.columnFilters.additionalFlag}`;

      return this.$http
        .get(baseURI + queryParams, { timeout: 60000 })
        .then((response) => {
          this.isLoading = false;
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
        })
        .catch((error) => {
          this.loading();

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    loadData() {
      this.isLoading = true;

      var params = this.$onBehind(this.$route.params.idBillingDetail);

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-detail/" +
        params[0];
      return this.$http
        .get(baseURI, { timeout: 60000 })
        .then(async (response) => {
          this.isLoading = false;
          this.forms = response.data.datas;
          this.forms.amountCategory = this.toCurrency(response.data.datas.amountCategory);
          this.rate = this.toCurrency(response.data.datas.rate);
          this.formsHeader = response.data.datas.bm_billing_header;
          if (this.forms.subDetailRateFlag === "Y") {
            await this.loadDataDetailHandling();
          }
        })
        .catch((error) => {
          this.isLoading = false;

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      this.roleName = userDatas.sub.role.name;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "BillingCmlController") {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();

    // Gunakan async/await untuk memastikan loadData selesai sebelum loadItems
    (async () => {
      try {
        await this.loadData();
        await this.loadItems();
      } catch (error) {
        console.error("Error during initialization:", error);
      }
    })();

    this.columns = this.getTableColumns();
  },
};
</script>
<style scoped>
.blur-content {
  filter: blur(5px);
}
</style>
